const NOMES_SUBETAPA_EXIBICAO: Record<string, string> = {
  "pv - revisar proposta - pendência backoffice": "PV - Revisar Proposta",
};

export const obterNomeEtapaExibicao = (
  nome: string | undefined | null,
  usuarioVivaz: boolean
): string => {
  if (!nome) return nome ?? "";
  if (usuarioVivaz && nome === "Secretaria") {
    return "Vendas";
  }
  return NOMES_SUBETAPA_EXIBICAO[nome.toLowerCase()] ?? nome;
};
